import { defineComponent as r, openBlock as t, createElementBlock as l, mergeProps as a, renderSlot as n } from "vue";
import "./ghl-ui.es218.js";
const s = r({
  name: "UIToolbarGroup",
  inheritAttrs: !1
}), d = r({
  ...s,
  props: {
    borderLeft: Boolean,
    borderRight: Boolean
  },
  setup(o) {
    return (e, p) => (t(), l("div", a(e.$attrs, {
      class: ["hl-toolbar-group", { "hl-br": o.borderRight, "hl-bl": o.borderLeft }]
    }), [
      n(e.$slots, "default")
    ], 16));
  }
}), f = d;
export {
  f as default
};
